module.exports = __webpack_public_path__ + "img/yellowalert-doubleLayer.6ba2df25.svg";